import React, { Component } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  Platform,
  ScrollView,
  StyleSheet,
  Animated,
  ImageBackground,
  ActivityIndicator,

  TouchableHighlight,
  SafeAreaView,
  Dimensions
} from "react-native";
import Toaster from './../../components/snackBar_toaster';

// import Share from 'react-native-share';
// import { WebView } from 'react-native-webview';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from 'react-native-vector-icons/FontAwesome';
// import { isIos, deviceWidth, deviceHeight, toFixed, shareImage } from './../Utils';
// import { TabView, TabBar, SceneMap } from 'react-native-tab-view';
// import AnalysisScreen from './analysisScreen';
// import AnswerScreen from './answerScreen';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import { resetAll } from './../../navigators/navigationService';
import { connect } from "react-redux";
// import { PieChart } from 'react-native-svg-charts';
import {
  testAnalysis,
  clearTestAnalysisData,
  // questionReport,
  // clearQuestionReportData,
} from "./../../store/action";

import { BarChart, PieChart } from "./../../components/charts/index";
// import Collapsible from 'react-native-collapsible';
import Collapse from '@material-ui/core/Collapse';
import {
  Checkbox,
  TextInput,
  Surface,
  Button,
  Modal,
  Provider,
  Portal,
} from "react-native-paper";
// import Toast, { DURATION } from 'react-native-easy-toast';
import moment from "moment";
// import OfflineHandler from './../OfflineHandler';
// import CountDown from 'react-native-countdown-component';
// import ViewShot from "react-native-view-shot";

// import AdComponent from './../Ads';
import {
  Text,
  Styles,
  ConverToTextComponent,
} from "./../../components/UI-Components";
import Icon from "@material-ui/core/Icon";
import Header from "./../../components/Header/index";
import BarChartIcon from "@material-ui/icons/BarChart";
import PieChartIcon from "@material-ui/icons/PieChart";
import Create from "@material-ui/icons/Create";
import Container from "@material-ui/core/Container";

const { width, height } = Dimensions.get('window')
const Loader = require("./../../assets/loadingGif.gif");
const examIcon = require('./../../assets/exam.png')

const secToMin = (secs) => {
  if(secs === null || !secs) return '00:00';
  return moment.utc(secs*1000).format('mm:ss');
}

const resultTypes = [
  {
      title: 'Correct',
      color: '#88e297'
  },
  {
      title: 'InCorrect',
      color: '#ffa8a8'
  },
  {
      title: 'UnAnswered',
      color: '#b2bac3'
  }
];

export function toFixed(x, y = 2) {
  return Number.parseFloat(x).toFixed(y);
}


const getColor = (ans) =>
  ans === "correct" ? "green" : ans === "wrong" ? "red" : "#000";

const OptionComponent = ({ isCorrect, i, option, isMathType }) => {
  const color = getColor(isCorrect);

  return (
    <View style={[styles.question_gap, { alignItems: 'center' ,justifyContent: 'center'}]}>
            {/* <Text style={{fontSize: 16, fontWeight: '400', marginTop: 2, color}}>
      {i}   
    </Text> */}
            <View
                style={{
                    height: 25,
                    width: 25,
                    backgroundColor: color === '#000' ? Styles.fiveMantraBgColor : color,
                    borderWidth: 4,
                    borderRadius: 50,
                    marginTop: 2,
                    borderColor: '#fff',
                    elevation: 8,
                    marginRight: 12,
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '2px 2px 4px #000'
                }}
            >
                <View style={{height: 13, width: 13, backgroundColor: color === '#000' ? Styles.fiveMantraBgColor : 'rgba(255,255,255,0.48)', borderRadius: 50}}>

                </View>
            </View>
            <View style={{ flex: 1 }}>
                <ConverToTextComponent text={option} color={color} isMathType={isMathType} />
            </View>
        </View>
  );
};

class TestAnalysisScreen extends React.Component {
  state = {
    modalVisible: false,
    // checked: false,
    questionCheck: false,
    answersCheck: false,
    explanationCheck: false,
    chart: true,
    testId: null,
    score: 80,
    index: 0,
    routes: [
      { key: "key", title: "Key" },
      //   { key: 'analysis', title: 'Analysis' },
    ],
    _score: [10, 90],
    test_details: {
      subject: "Indian Polity",
      questions: 10,
      attempt: 10,
      corrects: "10",
      wrongs: "02",
      isImageOpen: false,
    },
  };

  changeScore = (score) => this.setState({ score });

  //   static navigationOptions = ({navigation}) => ({
  //     headerRight:  (<Icon name={isIos ? 'ios-share' : 'md-share'} size={30} style={{ paddingLeft: 10, paddingRight: 20, color:'#000' }}
  //     onPress={() => {
  //       const shareImage = navigation.getParam('shareImage', null);
  //       if(typeof shareImage === 'function') {
  //         shareImage();
  //       }
  //      }}
  //     />)
  //   })

  componentDidMount() {
    this.fetchTestAnalysisData();
    // this.props.navigation.setParams({
    //   shareImage: this.shareImage
    // })
  }

  showToaster = (msg) => {
    this.setState({
      showToast: true,
      toasterMessage: msg
    })
  }

  componentDidUpdate(prevProps) {
    
    if (prevProps.correctQuestions !== this.props.correctQuestions) {
      if (this.props.correctQuestions) {
          const { test_type } = this.props.correctQuestions;

      }
  }


    if (prevProps.totalQuestions !== this.props.totalQuestions) {
      if (this.props.totalQuestions) {
        this.setState({
          _score: [
            this.props.totalQuestions.correct_count,
            this.props.totalQuestions.wrong_count,
          ],
        });
      }
    }

    if (prevProps.err !== this.props.err) {
      if (this.props.err) {
        const errorMessage =
          this.props.errInfo || "Please wait for test result.";
        if (!this.props.remainingTimeForShowResult) {
          this.showToaster(errorMessage, 1500);
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.clearTestAnalysisData();
  }

  fetchTestAnalysisData = () => {
    // const testId = this.props.navigation.getParam('testId', null);
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', null);
    // const isPlannedTest = this.props.navigation.getParam('isPlannedTest', false);
    const { state = {} } = this.props.location || {};
    const { testId = null, isTestSeries = null, isPlannedTest = null, isMaterialTest=false } =
      state || {};
    if (testId) {
      this.props.testAnalysis(testId, isPlannedTest, isTestSeries, isMaterialTest);
    }
  };

  isCorrectAnswer = (ans) =>
    ans === "correct"
      ? styles.correctAnswer
      : ans === "wrong"
      ? styles.wrongAnswer
      : {};

  highlightAnswers = (test, i) => {
    return test.correct_option === `option${i}`
      ? "correct"
      : test.correct_option !== `option${i}` &&
        test.user_option === `option${i}`
      ? "wrong"
      : null;
  };

  setModalVisible(visible) {
    this.setState({ modalVisible: visible });
    if (!visible) {
      this.setState({
        questionCheck: false,
        answersCheck: false,
        explanationCheck: false,
        eventDescription: "",
        submitClicked: false,
      });
    }
  }

  reportQuestion = () => {
    this.setState({ submitClicked: true });
    const {
      questionCheck,
      answersCheck,
      explanationCheck,
      eventDescription,
      collapsed, // question id
    } = this.state;

    const correction = [questionCheck, answersCheck, explanationCheck];
    let _correction_in = [];
    correction.map((c, i) => {
      if (c) {
        _correction_in.push(i + 1);
      }
    });

    const data = {
      test_id: this.props.requestedTestId,
      subject_id: 1,
      question_id: collapsed,
      correction_in: _correction_in.join(","),
      comments: eventDescription,
    };

    if (data && Object.keys(data).keys) {
      // this.props.questionReport(data);
    }
  };

  //   shareImage = () => {
  //     if(!this.props.answers) return console.log('not loaded!!');
  //     this.refs.viewShot.capture().then(uri => {
  //       // console.log(uri, 'uri');
  //       const options = {
  //         url: uri,
  //         message: 'https://2thepoint.page.link/appLink',
  //       }
  //       shareImage(options);

  //     });
  //   }
  backgroundImageClose = () => {
    this.setState({
      isImageOpen: false,
    });
  };

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };

  render() {
    const { testQuestions, answers, wrongQuestions, correctQuestions, unansweredQuestions, userScore, totalQuestions, testAnalysisResponse, userSubject, loading, } = this.props;
    const { subject_image, answered_questions } = testAnalysisResponse || {};
    // const { _score, submitTest, testQuestions, score, loading, err, answers, 
    return (
      <>
        <Header
          title="Result"
          headerRight
          headerRightClick={() => this.props.history.push('/Home')}
          // backButton={true}
        />
        {this.props.loading ? (
          <View
            style={{
              width: "100%",
              height: "90vh",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <ActivityIndicator /> */}
            <Image source={Loader} style={{ width: 250, height: 250 }} />
          </View>
        ) : null}
        {!this.props.loading && (
          <Container maxWidth="md">
            <div
              className={`${
                this.props.loading ? "main-component" : "full-height"
              } `}
            >
              <SafeAreaView style={{ flex: 1, backgroundColor: Styles.fiveMantraBgColor }}>
               

                {this.props.err &&
                  !this.props.remainingTimeForShowResult &&
                  !this.props.loading && (
                    <View style={{ flex: 1, marginTop: 10 }}>
                      <Text style={{ textAlign: "center" }}>
                        {this.props.errInfo &&
                        typeof this.props.errInfo === "string"
                          ? this.props.errInfo
                          : "Something went wrong..."}
                      </Text>
                    </View>
                  )}

                {!this.props.loading && answers && (
                  <ScrollView style={{flex: 1}}>
                    <View style={styles.resultComponent}>
                    <View style={styles.graph}>
                            {
                                answers ?
                                    <View style={{ flex: 1, width: '100%', height: 230, marginVertical: 8, position: 'relative', backgroundColor: Styles.fiveMantraBgColor, }}>
                                        <View style={{ flexDirection: 'row', backgroundColor: Styles.fiveMantraBgColor }}>

                                            {
                                                resultTypes.map((x, index) => {
                                                    return (
                                                    <div className='result_graph_type' key={index}>
                                                        <View style={{
                                                            width: 16, height: 16, borderWidth: 2.5, borderColor: '#fff',
                                                            backgroundColor: x.color, borderRadius: 50, marginRight: 2,
                                                           
                                                        }}></View>
                                                           <span className='results_info_type'>{x.title}</span>
                                                    </div>
                                                    )
                                                })
                                            }
                                        </View>

                                        {
                                            this.state.chart
                                                ?
                                                <PieChart
                                                correctQuestion={
                                                  correctQuestions
                                                }
                                                wrongQuestions={wrongQuestions < 0 ? 0 : wrongQuestions }
                                                unansweredQuestions={unansweredQuestions < 0 ? 0 : unansweredQuestions}
                                              />
                                                :
                                                <BarChart
                                                correctQuestion={
                                                  correctQuestions
                                                }
                                                wrongQuestions={wrongQuestions}
                                                unansweredQuestions={unansweredQuestions}
                                                />

                                        }

                                        <div className='change_chart_icon'>
                                            <TouchableOpacity
                                                hitSlop={{
                                                    top: 10,
                                                    bottom: 10,
                                                    right: 10,
                                                    left: 10
                                                }}
                                                onPress={() => this.setState({ chart: !this.state.chart })}
                                            >
                                                <Text>
                                                    {this.state.chart ? <BarChartIcon name={'bar-chart'} color={Styles.primaryColor} size={25} style={{ paddingLeft: 5 }} /> : <PieChartIcon name={'pie-chart'} color={Styles.primaryColor} size={25} style={{ paddingLeft: 5 }} />}
                                                </Text>
                                            </TouchableOpacity>
                                        </div>

                                    </View>
                                    : null

                            }

                        </View>
                        <View style={styles.resultsInfo}>
                            <View style={styles.content}>
                                <View style={{ marginRight: 10, alignSelf: 'center' }}>
                                  {
                                    subject_image ? 
                                    <Image source={{ uri: subject_image}} style={styles.imageComponent} />
                                    :
                                    <Image source={examIcon} style={styles.imageComponent} />
                                  }
                                
                                    {/* <Image source={{ uri: 'https://storage.googleapis.com/tothepointdemo.appspot.com/images/FQnWubI4z5L6w72RFUVqNd81ClBAot3wcYhlob09.png' }}
                                        style={{ width: 80, height: 80, }} /> */}
                                </View> 
                                <View style={{ flexDirection: 'column', flex: 1 }}>
                                    <View>
                                    <Text style={styles.titleOfContent}>{userSubject || '-'}</Text>
                                        <Text style={styles.titleOfContent}>{!!testAnalysisResponse && moment(testAnalysisResponse.test_time || testAnalysisResponse.attempt_date).format('D MMM hh:mm a')}</Text>
                                    </View>
                                    <View style={{ justifyContent: 'space-between', 
                                    flexDirection: 'row', flex: 1, 
                                    marginTop: 12, padding:width <= 579 ? 2 : 6, alignItems: 'center' }}>
                                        <View style={{
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            paddingVertical: width <= 579 ? 2  : 5,
                                            flexWrap: 'wrap', width: '70%',

                                        }}
                                        >
                                            <View style={{ flexDirection: 'row', flex: 1, width: '100%' }}>
                                                <View style={{ flex: 1, width: '48%' }}>
                                                    <View style={{ justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', width: '100%', }}>
                                                        <Text style={styles.titleOfContent}>Questions:
                                                    </Text>
                                                        <Text 
                                                        style={{ 
                                                          fontSize: width<= 579 ? 10 : 16, 
                                                          fontWeight: '700', 
                                                          color: '#000', 
                                                          alignSelf: 'flex-start', 
                                                          }}>{totalQuestions}</Text>
                                                    </View>
                                                    <View style={{ justifyContent: 'center', flexDirection: 'row', alignItems: 'center', width: '100%', margin: 4 }}>
                                                        <View style={{ borderWidth: 0.45, borderColor: 'rgba(0,0,0,0.15)', width: '70%', marginVertical: 2 }} />
                                                    </View>
                                                    <View style={{ justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', width: '100%', }}>
                                                        <Text style={styles.titleOfContent}>Correct:
                                                    </Text>
                                                        <Text style={{ fontSize: width<= 579 ? 10 : 16, fontWeight: '700', color: 'green', }}>{correctQuestions}</Text>
                                                    </View>
                                                </View>
                                                <View
                                                    style={{ width: '4%', justifyContent: 'center', alignSelf: 'center' }}
                                                ><View style={{ height: 35, backgroundColor: 'rgba(0,0,0,0.15)', alignSelf: 'center', width: 1, marginLeft: 6 }} /></View>
                                                <View style={{ flex: 1, width: '48%', }}>
                                                    <View style={{ justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', width: '100%', }}>
                                                        <Text style={{fontSize: width<= 579 ? 10 : 16, fontWeight: 'bold', marginLeft: 5 }}>Attempted:
                                                    </Text>
                                                        <Text style={{ fontSize:  width<= 579 ? 10 : 16, fontWeight: '700', color: Styles.primaryColor, }}>{answered_questions}</Text>
                                                    </View>

                                                    <View style={{ justifyContent: 'center', flexDirection: 'row', alignItems: 'center', width: '100%', margin: 4 }}>
                                                        <View style={{ borderWidth: 0.45, borderColor: 'rgba(0,0,0,0.15)', width: '70%', marginVertical: 2 }} />
                                                    </View>

                                                    <View style={{ justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', width: '100%', }}>
                                                        <Text style={{fontSize: width<= 579 ? 10 : 16, fontWeight: 'bold', marginLeft: 5}}>InCorrect:
                                                    </Text>
                                                        <Text style={{ fontSize: width<= 579 ? 10 : 16, fontWeight: '700', color: 'red', }}>{wrongQuestions}</Text>
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{backgroundColor:'#000', marginLeft: width<= 579 ? 12 : 0 ,  padding:width<= 579 ? 2 : 6, borderRadius: 10}}>
                                            <View style={{
                                                borderBottomWidth: 1,
                                                borderBottomColor: 'rgba(0,0,0,0.6)',
                                                marginHorizontal: 5,
                                            }}
                                            >
                                                <Text style={{ fontSize: 14, fontWeight: '600', color: '#a2a2a3' }}>Score</Text>
                                            </View>
                                            <View
                                                style={{
                                                    paddingHorizontal: width<= 579 ? 2 : 6,
                                                    width: '85%',
                                                    alignSelf: 'center',
                                                    height: 0.55,
                                                    backgroundColor: '#a2a2a3',
                                                    marginTop: 1,
                                                    marginBottom: 2
                                                }}
                                            />
                                            <View style={{
                                                borderBottomWidth: 1,
                                                borderBottomColor: 'rgba(0,0,0,0.6)',
                                                marginHorizontal: 5,
                                            }}
                                            >
                                                <Text style={{ fontSize: width<= 579 ? 15 : 22, fontWeight: '600', color: '#ffba00' }}>{userScore && toFixed(userScore)}</Text>
                                            </View>



                                        </View>
                                    </View>


                                </View>

                            </View>
                        </View>
                        <View style={{
                            flex: 1, marginHorizontal: 10, borderBottomWidth: 0.4,
                            borderBottomColor: 'rgba(0,0,0,0.6)', marginBottom: 10, paddingBottom: 10
                        }}>
                            <Text style={{ fontSize: 20, fontWeight: '700' }}> All Questions & Answers</Text>
                        </View>
                  
                      {this.props.answers && this.props.answers.length ? (
                        this.props.answers.map((item, index) => {
                          const { question: questionInfo, passage_question, question_id } = item || {};
                          const { id: passageId } = passage_question || {};
                          const { question, explanation, is_math_type, option1, option2, option3, option4 } = questionInfo || {};

                          const option1Color = this.highlightAnswers(item, 1);
                          const option2Color = this.highlightAnswers(item, 2);
                          const option3Color = this.highlightAnswers(item, 3);
                          const option4Color = this.highlightAnswers(item, 4);

                          return (
                            <View style={{ paddingRight: 5, marginRight: 10 }}>
                              <View key={index} style={styles.qstn_group}>
                                <View style={styles.question}>
                                  <View
                                    style={{
                                      width: 20,
                                      height: 20,
                                      backgroundColor: item.user_option
                                        ? "transparent"
                                        : "#29B6F6",
                                      borderRadius: 50,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      marginRight: 5,
                                      // marginTop: 10,
                                    }}
                                  >
                                    <Text
                                      style={{
                                        color: item.user_option
                                          ? "#000"
                                          : "#fff",
                                        fontSize: 12,
                                        fontWeight: "700",
                                      }}
                                    >
                                      {index + 1}
                                    </Text>
                                  </View>
                                  <View style={{ width: "95%" }}>
                                    <ConverToTextComponent
                                      text={question}
                                      isMathType={is_math_type}
                                      fontSize={16}
                                      style={{ marginTop: -4 }}
                                    />
                                  </View>
                                </View>
                                <OptionComponent
                                  isCorrect={option1Color}
                                  i={"a) "}
                                  option={option1}
                                  isMathType={is_math_type}
                                />

                                <OptionComponent
                                  isCorrect={option2Color}
                                  i={"b) "}
                                  option={option2}
                                  isMathType={is_math_type}
                                />

                                <OptionComponent
                                  isCorrect={option3Color}
                                  i={"c) "}
                                  option={option3}
                                  isMathType={is_math_type}
                                />

                                <OptionComponent
                                  isCorrect={option4Color}
                                  i={"d) "}
                                  option={option4}
                                  isMathType={is_math_type}
                                />

                         

                                {/* <View
                                  style={{
                                    flex: 1,
                                    justifyContent: "space-between",
                                    marginVertical: 0,
                                    flexDirection: "row",
                                  }}
                                >
                                  <TouchableOpacity
                                    onPress={() =>
                                      this.setState({
                                        collapsed:
                                          this.state.collapsed ===
                                          (item.question_id ||
                                            item.question_code)
                                            ? null
                                            : item.question_id ||
                                              item.question_code,
                                      })
                                    }
                                  >
                                    <Text
                                      style={{ color: "#5400FF", fontSize: 12 }}
                                    >
                                      Details
                                    </Text>
                                  </TouchableOpacity>
                                  {passageId && (
                                    <TouchableOpacity
                                      onPress={() => {
                                        this.props.history.push(
                                          "PassageViewer",
                                          {
                                            fromResult: true,
                                            passageId,
                                            question_id,
                                          }
                                        );
                                      }}
                                    >
                                      <Text
                                        style={{
                                          color: "#5400FF",
                                          fontSize: 12,
                                        }}
                                      >
                                        Show Passage
                                      </Text>
                                    </TouchableOpacity>
                                  )}
                                </View> */}
                                {/* <Collapse in={(this.state.collapsed === (item.question_id || item.question_code))} align="center" style={{ marginTop: 12 }}>
                                    <View style={{paddingBottom: 10}}>
                                      <Text style={styles.answerText}>Explanation:</Text>
                                      <ConverToTextComponent text={explanation || '<span> not found </span>'} isMathType={is_math_type} />
                                   
                                      {
                                        !isTestSeries && 
                                        <TouchableOpacity
                                          style={{ marginBottom: 10 }}
                                          onPress={() => {
                                            this.props.navigation.navigate('haveAnIssue', {
                                              subjectId: this.props.userSubjectId,
                                              questionId: item.question_id,
                                              isPlannedTest: this.state._isPlannedTest ? true : false
                                            })
                                            // this.setModalVisible(true);
                                          }}>
                                          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                            <Text style={{ color: 'red', marginVertical: 10, fontSize: 10 }}>Have an issue?</Text>
                                            <Create 
                                            // name={'pencil'}
                                            // color={'red'}
                                            //  size={10}
                                              style={{ paddingLeft: 5 , height: 5, width: 5, color: Styles.primaryColor}} />
                                          </View>
                                        </TouchableOpacity>
                                      }
                                    </View>
                                  </Collapse> */}
                              </View>
                            </View>
                          );
                        })
                      ) : !this.props.loading &&
                        this.props.answers &&
                        !this.props.answers.length ? (
                        <Text>No Data Found....</Text>
                      ) : null}
                    </View>
                  </ScrollView>
                )}

                {/* </BackHandlerAndroid> */}

                {/* <Toast
                ref="toast"
                position={'bottom'}
                positionValue={Colors.toastPositionValue}
                opacity={1}
                textStyle={{ color: Colors.toastTextColor }}
                style={{
                  marginBottom: 50,
                  backgroundColor: Colors.toastBgColor,
                  paddingHorizontal: Colors.toastPaddingHorizontal,
                  borderRadius: 20,
                }}
              />               */}
              </SafeAreaView>
            </div>
            <Toaster show={this.state.showToast}
                message={this.state.toasterMessage}/>
            </Container>
        )}

        {/* {
            !this.props.loading && 
                <AdComponent screenName = "ShowResults" isAdCallBack={this.isAd}/>
          } */}
      </>
      
    );
  }
}

const styles = StyleSheet.create({
  resultComponent: {
    marginHorizontal: 10,
    // paddingHorizontal: 10,
    marginTop: 12,
    marginBottom: 20,
    borderRadius: 10,
    flex: 1,
    paddingBottom: 0,
},
graph: {
  width: '100%',
  borderWidth: 3,
  borderColor: '#fff',
  // height: 200,
  flex: 1,
  backgroundColor: 'transparent',
  borderRadius: 10,
  flexDirection: 'column',
  justifyContent: 'flex-start'
},
  splashBackgroundImage: {
    flex: 1,
    // borderWidth:3,
    width: "100%",
    height: "100%",
    backgroundColor: "red",
    //  resizeMode: 'cover',
    //  alignItems:'center',
    //  justifyContent:'center'
  },
  mainContainer: {
    flex: 1,
    backgroundColor: "#fff",
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  roundBorder: {
    // flex: 1,
    // height: '100%',
    // flexDirection: 'row',
    marginVertical: 15,
    // marginHorizontal: 10,
    borderWidth: 0.7,
    borderColor: "#ccc",
    padding: 15,
    borderRadius: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  searchIcon: {
    marginRight: 10,
    paddingRight: 10,
    color: "#f4511e",
  },
  headingColor: {
    color: "#F5591F",
    fontSize: 18,
    fontWeight: "400",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
  },
  nameText: {
    marginLeft: 10,
    marginRight: 15,
    fontSize: 16,
    color: "#222",
    textAlign: "center",
    width: "50%",
    textAlign: "right",
  },
  scene: {
    flex: 1,
  },
  tabBar: {
    flexDirection: "row",
    // paddingTop: Constants.statusBarHeight,
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    fontSize: 30,
    // borderRightWidth: 1,
    // borderColor: 'red'
  },

  qstn_group: {
    marginBottom: 20,
    fontWeight: "700",
  },
  question: {
    fontSize: 14,
    fontWeight: "700",
    flexDirection: "row",
    // borderWidth:1,
    
  },
  qstn_nbr: {
    fontWeight: "700",
    // paddingRight: 5,
    flex: 1,
  },
  question_gap: {
    width: "95%",
    marginVertical: 7,
    flex: 1,
    flexDirection: "row",
    marginLeft: 6,
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  answerText: {
    fontSize: 14,
    // marginVertical:10,
    fontWeight: "700",
    marginRight: 10,
  },
  correctAnswer: {
    color: "green",
  },
  wrongAnswer: {
    color: "red",
  },
  components: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginVertical: 3,
  },
  resultsInfo: {
    marginBottom: 20, 
    borderRadius: 10, 
    paddingBottom: 10, 
    marginTop: 20, 
    borderWidth: 3,
    borderColor: '#fff',
  },
  content:{
    flex: 1, 
    flexDirection: 'row', 
    justifyContent: 'flex-start', 
    marginTop: 10, 
    padding:width <= 579 ? 8 : 16 
  },
  imageComponent:{
    width: width<= 579 ? 80  : 120,
    height: width<= 579 ? 80  : 120,
  },
  titleOfContent: {
    fontSize: width<= 579 ? 10 : 16, 
    fontWeight: '700', 
  }
});

const maps = (state) => ({
  loading: state.testAnalysis && state.testAnalysis.loading && state.testAnalysis.loading,
  err: state.testAnalysis && state.testAnalysis.error,
  errInfo: state.testAnalysis && state.testAnalysis.errorInfo && state.testAnalysis.errorInfo.data && state.testAnalysis.errorInfo.data.message,
  errInfoStatus: state.testAnalysis && state.testAnalysis.errorInfo && state.testAnalysis.errorInfo.data && state.testAnalysis.errorInfo.data.status,
  remainingTimeForShowResult: state.testAnalysis && state.testAnalysis.errorInfo && state.testAnalysis.errorInfo.data && state.testAnalysis.errorInfo.data.time_remaining,
  answers: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.user_responses && state.testAnalysis.response.user_responses,
  testQuestions: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.user_responses && state.testAnalysis.response.user_responses,
  totalQuestions: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.total_questions,
  wrongQuestions: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response?.wrong_count,
  unansweredQuestions: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.unanswered_questions,
  correctQuestions: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response?.correct_count,
  attemptUser: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response,
  testAnalysisResponse: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response,
  userScore: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.user_score,
  winner: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.winner,
  userSubject: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.subject && state.testAnalysis.response.subject,
  userSubjectId: state.testAnalysis && state.testAnalysis.response && state.testAnalysis.response.subject && state.testAnalysis.response.subject_id,
  // totalQuestions: state.submitTest && state.submitTest.Total_Questions && state.submitTest.Total_Questions,
  _score: state.submitTest && state.submitTest.response && state.submitTest.response.score && state.submitTest.response.score,
  questionReportLoading: state.questionReport && state.questionReport.loading,
  questionReportError: state.questionReport && state.questionReport.error,
  questionReportErrorInfo: state.questionReport && state.questionReport.errorInfo,
  sendQuestionReport: state.questionReport && state.questionReport.response && state.questionReport.response.status,
  requestedTestId: state.testAnalysis && state.testAnalysis.requestedTestId,
});
export default connect(maps, {
  testAnalysis,
  clearTestAnalysisData,
  // questionReport,
  // clearQuestionReportData,
})(TestAnalysisScreen);
